import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import _ from 'underscore';

const prepareAreaTypeOptions = (list) => {
    return _.map(list, (item) => {
        return { text: item, value: item}
    })
};

const ClinicListFilterByArea = (props) => {
    const sortedAreaTypeList = _.sortBy(props.areaList, (area) => area);
    const areaTypeOptions = prepareAreaTypeOptions(sortedAreaTypeList);
    const updateFilterOptions = (e, { value}) => {
        props.updateClinicFilterOptions({filterByArea: value});
        props.updateMode(3, null);
    }
    return (
        <Dropdown 
            placeholder='Select Area' 
            onChange={updateFilterOptions}
            fluid 
            search
            selection 
            options={areaTypeOptions} 
            value={props.filterOptions.filterByArea}
        />
    );
}

export default ClinicListFilterByArea;